import { call, put, all } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import notify from 'devextreme/ui/notify';
import * as actions from '../actions/settings';
import {
  get,
  post,
  axiosPut,
  del
} from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';
import { startLoading, stopLoading } from '../actions/settings/loading';
import { getLocale } from '../../utils/functions';

export function* getSettingsPlant({ payload }) {
  try {
    const response = yield call(get, `/settings/plant?plant=${payload.plant}`);
    yield put(actions.getSettingsPlantSuccess(response));
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getSettingsPlantFail());
  }
}

export function* getHolderSettingsPlant({ payload }) {
  try {
    const response = yield call(get, `/settings/holder_report/plant?plant=${payload.plant}`);
    yield put(actions.getHolderSettingsPlantSuccess(response));
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getHolderSettingsPlantFail());
  }
}

export function* setSettingsPlant({ payload }) {
  try {
    yield call(
      post,
      `/settings/plant?plant=${payload.plant}&settingId=${payload.settingId}&value=${payload.value}`,
      null
    );
    yield put(actions.setSettingsPlantSuccess());
    notify(
      {
        message: formatMessage('dataSuccess'),
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
    yield put(actions.getSettingsPlant({ plant: payload.plant }));
    yield put(actions.getHolderSettingsPlant({ plant: payload.plant }));
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.setSettingsPlantFail());
  }
}

/** Работа с сообщений */
export function* messageList({ payload }) {
  try {
    const showAll = payload.showAll;
    const response = yield call(get, `/user_message/list?shipping_type=${payload.messageShippingType}${showAll ? '&showAll=true' : '&showAll=false'}`);
    yield put(actions.messageListSuccess(response));
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.messageListFail());
  }
}

export function* messageSave({ payload }) {
  try {
    yield call(
      axiosPut,
      `/user_message/${payload.userMessageNumId}`,
      {
        messageDate: payload.messageDate,
        activeToDate: payload.activeToDate,
        messageTitle: payload.messageTitle,
        messageText: payload.messageText,
        messageType: payload.messageType,
        shippingType: payload.messageShippingType
      }
    );
    yield put(actions.messageSaveSuccess());
    notify(
      {
        message: formatMessage('textSuccess'),
        height: 64,
        width: 354,
        position: { at: 'top center', my: 'top center', offset: '0 48' }
      },
      'success',
      2000
    );
    yield put(actions.messageList({ messageShippingType: payload.messageShippingType, showAll: true }));
    yield put(actions.messageClear());
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.messageSaveFail());
  }
}

export function* messageDelete({ payload }) {
  try {
    yield call(
      del,
      `/user_message/${payload.userMessageNumId}`
    );
    yield put(actions.messageDeleteSuccess());
    notify(
      {
        message: formatMessage('textSuccess'),
        height: 64,
        width: 354,
        position: { at: 'top center', my: 'top center', offset: '0 48' }
      },
      'success',
      2000
    );
    yield put(actions.messageList({ messageShippingType: payload.messageShippingType, showAll: true }));
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message || formatMessage('textError').textErrorDeleteMessage,
        techInfo: e.response.data.techInfo,
        types: 'error',
        title: formatMessage('error')
      })
    );
    yield put(actions.messageDeleteFail());
  }
}

export function* getMessageTemplate({ payload }){
  try {
    const response = yield call(get, `/user_message?shipping_type=${payload.shippingType}`);
    yield put(actions.getMessageTemplateSuccess(response));
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: 'Не удалось создать новую новость. Повторите попытку позже',
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getMessageTemplateFail());
  }
}

export function* messageGetPhotosList({ payload }) {
  try {
    yield put(startLoading());
    const response = yield call(
      get,
      `/user_message/attachment_list?userMessageNumId=${payload.userMessageNumId}`
    );
    yield put(actions.getMessageFilesListSuccess(response));
    yield put(stopLoading());
  } catch (error) {
    yield put(actions.getMessageFilesListFail());
    yield put(stopLoading());
    yield put(
      modalErrorOpen({
        message: error.response?.data?.message,
        techInfo: error.response?.data?.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}

export function* messageAddPhoto({ payload }) {
  try {
    yield put(startLoading());

    yield all(payload.files.map((file) => {
      const formData = new FormData();
      formData.append('userMessageNumId', payload.userMessageNumId);
      formData.append('pictureFile', file);
      return call(
        post,
        '/user_message/attachment/upload',
        formData,
        {
          headers: {
            'Accept-Language': getLocale(),
            'Content-Type': 'multipart/form-data'
          }
        }
      );
    }));
    yield put(actions.addMessageFilesSuccess());
    yield put(actions.getMessageFilesList({
      userMessageNumId: payload.userMessageNumId
    }));
    yield put(stopLoading());
  } catch (error) {
    yield put(stopLoading());
    yield put(actions.addMessageFilesFail());
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}

export function* messageDeletePhoto({ payload }){
  try {
    yield put(startLoading());
    yield call(del, `/user_message/attachment?ids=${payload.files.join(',')}`);
    yield put(actions.deleteMessageFilesSuccess());
    yield put(stopLoading());
    yield put(actions.getMessageFilesList({
      userMessageNumId: payload.userMessageNumId
    }));
  } catch (e) {
    yield put(stopLoading());
    yield put(actions.deleteMessageFilesFail());
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}

export function* messageRead({ payload }) {
  try {
    yield call(post, `/user_message/read`, payload);
    yield put(actions.messageReadSuccess());
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.messageReadFail());
  }
}

export function* setSettingsTNPlant({ payload }) {
  try {
      for ( const props in payload.settingsTN) {
        yield call(
          post,
          `/settings/plant?plant=${payload.plant}&settingId=${props}&value=${payload.settingsTN[props]}`,
          null
        );
      }
    yield put(actions.setSettingsTNPlantSuccess());
    notify(
      {
        message: formatMessage('dataSuccess'),
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
    yield put(actions.getSettingsPlant({ plant: payload.plant }));
    yield put(actions.getHolderSettingsPlant({ plant: payload.plant }));
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.setSettingsTNPlantFail());
  }
}
